import React from "react";
import PropTypes from "prop-types";

function ButtonPill({ id, label, type, disabled, cypressid, style: userStyles = {}, onClick, children, props }) {
  return (
    <button
      disabled={disabled}
      style={{ minHeight: '44px', ...userStyles }}
      className='btn-pill m-2'
      id={id}
      type={type}
      onClick={onClick}
      cypressid={cypressid}
      {...props}
    >
      {label}
      {children}
    </button>
  );
}

ButtonPill.defaultProps = {
  id: "deq-primary",
  type: "button",
  disabled: false
};

ButtonPill.propTypes = {
  /** Label for button */
  label: PropTypes.string,

  /** Background color to use:
   * Refer to the CSS 'themes' file for all possible background color references
   */

  id: PropTypes.string,

  /** style object - Allow users to create inline styles */
  style: PropTypes.object,

  /**Type of Button */
  type: PropTypes.string,

  /** Notes whether or not button is clickable */
  disabled: PropTypes.bool
};

export default ButtonPill;
